import React from 'react';

const TooltipIcon = ({ onClick }) => (
  <a className="info-icon-for-select ms-2">
    <i className="fa fa-question-circle" onClick={onClick} />
  </a>
);

export default TooltipIcon;